import { combineReducers, createStore } from 'redux';
import userReducer, { IUser } from "./user/userReducer";
import { composeWithDevTools } from 'redux-devtools-extension'
import projectReducer, { IProject } from './project/projectReducer';
import progressReducer, { IProgress } from './progress/progressReducer';


export interface IState {
    user: IUser,
    project: IProject,
    progress: IProgress
}


const rootReducer = combineReducers({ user: userReducer, project: projectReducer, progress: progressReducer });

let store = createStore(rootReducer, composeWithDevTools());

export default store;